var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component",attrs:{"subscriptionOnboarding":_vm.subscriptionOnboarding},on:{"closeWelcome":_vm.closeWelcome,"skip":_vm.skipSubscriptionOnboarding}},[_c('router-view')],1),_c('SplashScreen'),_c('LmsToaster'),_c('CookiesNotification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }